import { Component } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { Location } from '@angular/common';
import { LoggingService } from '../../log/logging.service';
import { MenuTreeItem } from '../../core/services/menu/menu-tree-item';
import { AppMenuService } from '../../core/services/menu/app-menu.service';
import { environment } from '../../../environments/environment';
import { AppPermissionService } from '../../core/services/app-permission.service';
import { FormatConfigService } from '../../core/services/format-config.service';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { AppImageConfig } from '../../core/services/app-image-config';
import { ImageConfigEntry } from '../../core/base-api';
import { MizenAngularLibService } from 'mizen-angular-lib';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from '../../core/extension/header/cap-header.component';
import { MizenInboxComponent } from '../../core/extension/mizen-inbox/mizen-inbox.component';
import { UserPickerComponent } from '../../core/extension/user-picker/user-picker.component';
import { EnvironmentMarkerComponent } from '../environment-marker/environment-marker.component';
import { NavMenuComponent } from '../../core/extension/navigation/cap-nav-menu.component';
import { CapNavItemComponent } from '../../core/extension/navigation/cap-nav-item.component';
import { CapAlertListComponent } from '../../core/extension/exceptions/cap-alert-list.component';
import { RouterOutlet } from '@angular/router';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'cap-intercapi-layout',
  templateUrl: './intercapi-layout.component.html',
  styleUrls: ['./intercapi-layout.component.scss'],
  imports: [
    HeaderComponent,
    MizenInboxComponent,
    UserPickerComponent,
    EnvironmentMarkerComponent,
    NavMenuComponent,
    CapNavItemComponent,
    CapAlertListComponent,
    RouterOutlet,
    TranslatePipe
  ]
})
export class IntercapiLayoutComponent extends AbstractComponent {
  root: MenuTreeItem;

  passwortAendernParam: boolean = false;
  emailAendern: boolean = false;

  private readonly imageElementToImagePathMapping: Map<ImageConfigEntry.ElementEnum, string> = new Map();
  logoPath: string;

  keycloak: Keycloak;

  constructor(
    private readonly menuService: AppMenuService,
    public location: Location,
    private readonly permissionService: AppPermissionService,
    private readonly formatService: FormatConfigService,
    private readonly mizenAngularLibService: MizenAngularLibService,
    private readonly translateService: TranslateService,
    public service: LoggingService
  ) {
    super();
    keysToTranslate<string>([
      'layouts.toolbar.de',
      'layouts.toolbar.fr',
      'layouts.page.title',
      'layouts.page.titleNavigation',
      'layouts.settings',
      'layouts.entwicklungsUmgebung',
      'layouts.testUmgebung',
      'layouts.GeschichteEinAus'
    ]);
    this.addSub(
      this.formatService.parameterConfig$.subscribe((config) => {
        if (config) {
          this.passwortAendernParam = !!config.parameters.PASSWORT_IN_INTERCAPI_AENDERN;
          this.emailAendern = !!config.parameters.EMAIL_IN_INTERCAPI_AENDERN && !environment.bbvEnabled;
        }
      })
    );
    this.addSub(this.menuService.menu$.subscribe((value: MenuTreeItem) => (this.root = value)));
    const issuer = environment.openIdConnect.issuer;
    const url = issuer.substring(0, issuer.indexOf('/realms'));
    const realm = issuer.substring(issuer.indexOf('/realms') + '/realms/'.length).replace('/', '');
    const config = {
      url: url,
      realm: realm,
      clientId: environment.openIdConnect.clientId
    };
    this.keycloak = new Keycloak(config);
    this.keycloak
      .init({
        useNonce: true
      })
      .then((_) => {});

    this.initAppLogo();
  }

  openPasswortAendern() {
    this.keycloak
      .login({
        action: 'UPDATE_PASSWORD',
        locale: this.translateService.getCurrentLang()
      })
      .then((_) => {});
  }

  openAccountManagement() {
    this.keycloak.accountManagement().then((_) => {});
  }

  private initAppLogo() {
    this.imageElementToImagePathMapping.set('APP_LOGO_DEFAULT', '');
    this.imageElementToImagePathMapping.set('APP_LOGO_BS', 'assets/img/wappen/bs.png');
    this.addSub(this.formatService.imageConfig$.subscribe((config) => this.updateLogo(config)));
  }

  private updateLogo(imageConfig: AppImageConfig) {
    if (!imageConfig) {
      return;
    }
    const configuredImageElement = imageConfig.getImageFormatForCurrentLanguage('APP_LOGO');
    if (configuredImageElement && configuredImageElement.element) {
      this.logoPath = this.imageElementToImagePathMapping.get(configuredImageElement.element);
    }
    if (!this.logoPath) {
      this.logoPath = this.imageElementToImagePathMapping.get('APP_LOGO_DEFAULT');
    }
  }

  isMizenEnabled(): boolean {
    return this.mizenAngularLibService.isEnabled();
  }

  get hasPermissionConfigManager() {
    return this.permissionService.hasPermission('CONFIGMANAGER');
  }
}
